"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var RowMaker_1 = __importDefault(require("containers/TableMaker/RowMaker"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var analytics_1 = require("utils/analytics");
var backend_1 = require("utils/backend");
var single_1 = require("utils/selectors/single");
var selectors_1 = require("../selectors");
var tableConf_1 = require("../tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.invitedUsersTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.invitedUsersTableConf);
var InvitedUsers = function () {
    var _a = __read(react_1.default.useState(false), 2), isResendingAll = _a[0], setIsResendingAll = _a[1];
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var invitations = (0, react_redux_1.useSelector)(selectors_1.selectPopulatedInvitations);
    var userTypes = end2end_1.IS_RECHARGLY ? ['userRechargly'] : ['accountantAddsOwner', 'billingOwner', 'admin', 'user'];
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{
            collection: 'invitations',
            where: [['companyId', '==', (myCompany === null || myCompany === void 0 ? void 0 : myCompany.id) || ''], ['type', 'in', userTypes]],
        }]; });
    var sortedInvitedUsers = (0, hooks_1.useSortArray)(invitations, tableConf_1.invitedUsersTableConf.extractors);
    var track = (0, analytics_1.usePreparedTracker)('User Invite');
    if (!(0, react_redux_firebase_1.isLoaded)(invitations)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var unusedInvitations = sortedInvitedUsers === null || sortedInvitedUsers === void 0 ? void 0 : sortedInvitedUsers.filter(function (inv) { return !inv.usedBy; });
    var resendAll = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsResendingAll(true);
                    track({ action: 'Resend All', count: Array.isArray(unusedInvitations) ? unusedInvitations.length : 0 });
                    if (!unusedInvitations) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(unusedInvitations.map(function (inv) { return (0, backend_1.callBackendFn)('invitations-resendInvitation', inv.id); }))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    setIsResendingAll(false);
                    return [2 /*return*/];
            }
        });
    }); };
    if ((0, react_redux_firebase_1.isEmpty)(unusedInvitations)) {
        return (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3, align: "center" }, { children: "No users found" }));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ height: "100%", pb: 5 }, { children: [(0, jsx_runtime_1.jsxs)(Table_1.default, { children: [(0, jsx_runtime_1.jsx)(Header, {}), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: unusedInvitations === null || unusedInvitations === void 0 ? void 0 : unusedInvitations.map(function (user) { return (0, jsx_runtime_1.jsx)(Row, { item: user }, user.id); }) })] }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(LineButton_1.default, __assign({ color: "green", onClick: resendAll, isSending: isResendingAll }, { children: "Resend all invites" })) }))] })));
};
exports.default = (0, SortHoC_1.default)(InvitedUsers, { key: 'email', order: 1 });
